
export const routesOfEAForEU = (builder) => ({
    routesOfEAForEU: builder.mutation({
      query: ({}) => {
        const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';
        return {
          url: '/get_assigned_route_enterprise_user',
          method: 'GET',
          params: {  },
          headers: {
            'Content-Type': 'application/json',
            'Authorization': token
          },
        }
      },
    }),
  });